function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#FFF",
  strokeLinecap: "round",
  strokeWidth: 2
}, React.createElement("path", {
  d: "M1 1.95l11.694 11.693M1 13.643L12.694 1.949"
}));

const SvgComponent = props => React.createElement("svg", _extends({
  width: 14,
  height: 15,
  viewBox: "0 0 14 15"
}, props), _ref);

export default __webpack_public_path__ + "static/media/close-x.cc317ee5.svg";
export { SvgComponent as ReactComponent };